import axios, { AxiosError } from 'axios';
import type { Tokens } from '@/types';
import { API_BASE_URL } from '@/utils/env';

let accessToken: string | null = null;

export const setAccessToken = (token: string | null) => {
  accessToken = token;
};

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
  withCredentials: true, // ✅ 跨域请求时自动带上 Cookie（用于 OAuth 流程）
});

type ErrorPayload = {
  message?: string;
  errors?: Array<{ msg: string; param?: string }>;
};

apiClient.interceptors.request.use((config) => {
  if (!config.headers) {
    config.headers = {} as any;
  }

  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }

  return config;
});

export const extractErrorMessage = (error: unknown): string => {
  if (axios.isAxiosError(error)) {
    const axiosError = error as AxiosError<ErrorPayload>;
    if (axiosError.response?.data?.message) {
      return axiosError.response.data.message;
    }
    return axiosError.message;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return 'Unexpected error occurred';
};

export const updateStoredAccessToken = (tokens: Tokens | null) => {
  setAccessToken(tokens?.accessToken ?? null);
};
